export default __webpack_public_path__ + "static/media/img3.82d3501d.jpg";